import React, { useState, useEffect } from 'react';
import { useUser } from '../contexts/UserContext';
import Swal from 'sweetalert2';
import { useAccesos } from '../contexts/AccesosContext';
function AddPais({ handleNewPais, editPais }) {
    const server = process.env.REACT_APP_API_ROUTE;
    const key = process.env.REACT_APP_API_KEY;
    const [nombre, setNombre] = useState('');
    const [IngresadoPor, setIngresadoPor] = useState('');

    const [modificacion, setModificacion] = useState('');

    const { user } = useUser();
    const { tienePermiso } = useAccesos();
    // Obtener la fecha y hora actual
    function obtenerFechaISOsinZ() {
        const fecha = new Date();
        let fechaISO = fecha.toISOString(); // "2024-07-30T22:14:46.271Z"
        fechaISO = fechaISO.slice(0, -1); // Elimina la última posición, que es la 'Z'
        return fechaISO;
    }

    // Convertir a una cadena en formato ISO 8601
    const fechaFormateada = obtenerFechaISOsinZ();
    console.log(fechaFormateada);
    useEffect(() => {
        if (editPais) {
            setModificacion(2);
            setNombre(editPais.nombrePais); // Cargar el nombre del país para editar
            setIngresadoPor(editPais.ingresadoPor);
            console.log(editPais);
        } else {
            setNombre(''); // Resetear el nombre si no estamos editando
            setModificacion(1);
            setIngresadoPor('');
        }
    }, [editPais]);


    const handleSubmit = async (e) => {
        e.preventDefault();
        const method = editPais ? 'PUT' : 'POST';
        const endpoint = editPais ? `${server}/MgPaises/${editPais.idPais}` : `${server}/MgPaises`;

        
        const pais = {
            idPais: editPais ? editPais.idPais : 0,
            nombrePais: nombre,
            IngresadoPor: !editPais ? (user ? user.codigoUsuario : 'ADMIN               ') : IngresadoPor,
            ModificadoPor: editPais ? (user ? user.codigoUsuario : 'ADMIN               ') : undefined,
           // modificacion,
        };
        console.log(pais);
        // Remove undefined properties
        Object.keys(pais).forEach(key => pais[key] === undefined && delete pais[key]);
        console.log(pais);

        try {
            const response = await fetch(endpoint, {
                method: method,
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(pais),
            });

            if (response.ok) {
                setNombre('');
                Swal.fire({
                    icon: 'success',
                    title: 'Operación exitosa',
                    showConfirmButton: false,
                    timer: 1500
                });
                handleNewPais();
            } else {
                const errorData = await response.json();
                const errorMessage = errorData.message || (errorData.errors ? Object.values(errorData.errors).flat().join(', ') : 'Ocurrió un error inesperado');
                Swal.fire({
                    icon: 'error',
                    title: `Error ${response.status}`,
                    text: errorMessage,
                });
            }
        } catch (error) {
            console.error('Error al agregar pais', error);
            Swal.fire({
                icon: 'error',
                title: 'Error al guardar el país',
                text: error || 'Ocurrió un error inesperado',
            });
        }
    };
    return (
        <>
            <h2>Gestión de Paises</h2>
            <br />
            <form id="Perfiles" data-parsley-validate className="form-horizontal form-label-left" onSubmit={handleSubmit}>
                <div className="item form-group">
                    <label className="col-form-label col-md-3 col-sm-3 label-align" htmlFor="nombrePerfil">
                        Nombre Pais: <span className="required">*</span>
                    </label>
                    <div className="col-md-2 col-sm-3">
                        <input
                            type="text"
                            id="nombrePerfil"
                            required="required"
                            className="form-control"
                            value={nombre}
                            onChange={(e) => setNombre(e.target.value)}
                        />
                    </div>
                </div>

                <div className="ln_solid" />
                <div className="item form-group">
                    <div className="col-md-6 col-sm-6 offset-md-3">
                        {/* <button className="btn btn-primary" type="reset">Limpiar</button> */}
                        <button type="submit" className="btn btn-success" disabled={!tienePermiso('Crear País')}>{editPais ? 'Actualizar' : 'Guardar'}</button>
                    </div>
                </div>
            </form>
        </>
    )
}

export default AddPais